module.exports = __webpack_public_path__ + "static/media/playbutton.2411b9b9.png";